import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import { useTranslation } from "react-i18next";
import Layout from "../../../components/Layout";
import UserViewContent from "../../../components/Pages/Users/View";

const { displayName } = config;

export default function UsersView(): React.ReactNode | null {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Users`;
  }, []);

  return (
    <Layout>
      <UserViewContent />
    </Layout>
  );
}
